import { Checkbox } from 'antd'
import { FC } from 'react'

interface ShipmentWithoutCuttingProps {
    checked?: boolean
}

const ShipmentWithoutCutting: FC<ShipmentWithoutCuttingProps> = ({ checked }) => {
    return <Checkbox checked={checked} />
}

export default ShipmentWithoutCutting

